import type { AxePurchaseState, v2 } from '@deque/billing-service-client';
import type { ProductSlugs } from '@deque/billing-utils';
import { apiRequest } from '../../api-client';
import type { SubscriptionEnvironment } from './add-subscription';

export interface CreateEnterpriseWithSubscriptionParams {
  token: string;
  name: string;
  enterprise_stripe_email?: string;
  root_group?: string;
  auto_add_users?: boolean;
  product_slug: ProductSlugs | string;
  purchase_state: AxePurchaseState;
  license_count?: number;
  unit_count?: number;
  metrics?: v2.CreateEnterpriseSubscriptionParams['metrics'];
  start_date: string;
  end_date: string;
  trial_expires?: string;
  environment?: SubscriptionEnvironment;
  customer_email?: string;
  make_customer_contact_admin?: boolean;
  product_url?: string;
  sub_group?: string;
  monitor_v8?: boolean;
}

export interface CreateEnterpriseWithSubscriptionResponse {
  enterprise: v2.Enterprise;
  subscription: v2.EnterpriseSubscription;
  invitation_error?: string;
}

/**
 * Create a new enterprise and its first subscription in a single request.
 * POST /api-internal/enterprise-with-subscription
 */
export function createEnterpriseWithSubscription({
  token,
  ...body
}: CreateEnterpriseWithSubscriptionParams): Promise<CreateEnterpriseWithSubscriptionResponse> {
  return apiRequest({
    method: 'POST',
    endpoint: '/api-internal/enterprise-with-subscription',
    token,
    body
  });
}
